<template>
  <div>
    
    <div class="programs sec-mt">
      <div class="swiper-programs">
        <div class="container">
          <div class="vc-arros d-flex align-items-center justify-content-between">
            <button class="swiperPrev" slot="button-prev" @click="prev()"><span class="icon-arrow-left"></span></button>
            <div class="bg-title">Our Programs</div>
            <button class="swiperNext" slot="button-next" @click="next()"><span class="icon-arrow-right"></span></button>
          </div>
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(row, index) in rows" :key="index">
              <div>
                <img :src="row.image" alt="" />
                <div :style="{backgroundColor: row.bgColor}" class="wsf-program-views">
                    <div class="bg-title" v-html="row.title"></div>
                    <router-link :to="row.redirect" class="btn-primary d-inline-block">
                      <div class="d-flex align-items-center">Read More <span class="icon-arrow-right ml-2"></span></div>
                    </router-link>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.bg-title {
  color: #170469 !important;
  font-size: 32px;
  font-weight: bold;
}
.vc-arros {
  padding: 22px 0
}
.vc-arros span {
  font-size: 33px;
  font-weight: bold;
}
.content-caorusel-bs h1,
.content-caorusel-bs span,
.content-caorusel-bs p {
  line-height: 1;
  margin: 0;
}
.wsf-program-views {
  padding: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
h1 {
  margin: 0;
  line-height: 1;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {}

@media (max-width: 767.98px) {
  .programs .content {
    padding: 21px;
    height: auto
  }
  .main-banner .banner-content .content .title {
    font-size: 19px;
  }
  .wsf-program-views .bg-title {
    width: calc(100% - 130px);
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .wsf-program-views .bg-title {
    width: calc(100% - 130px);
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Section2",
  props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      pgLoading: true,
      rows: [],
      swiperOptions: {
        loop: false,
        autoplay: false,
        spaceBetween: 30,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        breakpoints: {
          767: {
            slidesPerView: 1
          },
          800: {
            slidesPerView: 2
          },
          1200: {
            slidesPerView: 2
          }
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  created() {
      this.fetchSlider();
  },
  methods: {
    prev() {
			this.$refs.mySwiper.$swiper.slidePrev();
		},
		next() {
			this.$refs.mySwiper.$swiper.slideNext();
    },
    fetchSlider() {
      axios
        .get(window.baseURL + "/programsInHome")
        .then((res) => {
          this.pgLoading = false;
          const data = res.data.row;
          this.rows = data;
          console.log(data);
        })
        .catch(() => {});
    },
  },
};
</script>
